<div id="{{ card.id }}" [attr.data-automation-id]="card.automationId"
  class="dx-workflow-card bl-block-module"
  [class.bl-disabled-card]="!card.enabled">
  <cu-dynamic-card-header [page]="page" [card]="card" [pageSubmitted$]="pageSubmitted$"></cu-dynamic-card-header>
  <cu-dynamic-card-validation [page]="page" [card]="card" [pageSubmitted$]="pageSubmitted$"></cu-dynamic-card-validation>
  <cu-dynamic-card-fields [page]="page" [card]="card" [pageSubmitted$]="pageSubmitted$" [cardIndex]="cardIndex"></cu-dynamic-card-fields>
  <cu-dynamic-card-footer [page]="page" [card]="card" [pageSubmitted$]="pageSubmitted$" [cardIndex]="cardIndex"></cu-dynamic-card-footer>
</div>
